<template>
  <a-spin :spinning="loading" tip="Processing...">
    <div class="card mb-3" style="min-height: 60vh;">
      <div class="card-body" style="padding-top: 50px;">
        <h3>Job Monitoring</h3>
    <div class="col-md-12" style="padding: 10px; height: auto;">
      <a-table :columns="columns" :dataSource="jobList" :pagination="pagination">
        <template slot="download-column" slot-scope="profile_name, record">
          <div v-if="profile_name.includes('full_sync_export') && record.formatted_status === 'Done'">
            <a-button type="primary" @click.prevent="downloadExport(record)">
              Download
            </a-button>
          </div>
          <!-- <button @click="logEvent">download</button> -->
        </template>
        <p slot="expandedRowRender" slot-scope="record" style="margin: 0">
          <a-list bordered :dataSource="record.import_errors">
            <a-list-item slot="renderItem" slot-scope="item">{{ item }}</a-list-item>
            <div slot="header">Errors</div>
          </a-list>
          <a-list bordered :dataSource="record.import_info">
            <a-list-item slot="renderItem" slot-scope="item">{{ item }}</a-list-item>
            <div slot="header">Info</div>
          </a-list>
        </p>
      </a-table>
    </div>
  </div>
  <!-- <div>
        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card mb-3">
                        <div class="col-md-12">
                            <br>
                            <h2>Job Monitoring</h2>
                            <br>
                            <a-table :columns="columns" :dataSource="jobList" :pagination="pagination">
                                <p slot="expandedRowRender" slot-scope="record" style="margin: 0">
                                    <a-list bordered :dataSource="record.import_errors">
                                      <a-list-item slot="renderItem" slot-scope="item">{{item}}</a-list-item>
                                      <div slot="header">Errors</div>
                                    </a-list>
                                </p>
                            </a-table>
                            <br><br>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
  </div>
  </a-spin>
</template>

<script>

const columns = [
  { title: 'Profile Name', dataIndex: 'profile_name', key: 'profile_name' },
  { title: 'Time Start', dataIndex: 'formatted_created_at', key: 'formatted_created_at' },
  { title: 'Time End', dataIndex: 'formatted_time_end', key: 'formatted_time_end' },
  { title: 'Progress', dataIndex: 'current_status', key: 'current_status' },
  { title: 'Status', dataIndex: 'formatted_status', key: 'formatted_status' },
  { title: 'Created By', dataIndex: 'created_by', key: 'created_by' },
  { title: "Action", dataIndex: "profile_name", key: "action", scopedSlots: { customRender: "download-column" } }
];

import HTTPRequest from '../controllers/httpRequest.js'
import secureStorage from './../controllers/secureStorage';
import { mapState, mapActions } from 'vuex'
// import moment from 'moment';
import axios from "axios";

export default {
  data() {
    return {
      jobList: null,
      columns: columns,
      pagination: false,
      loading: false,
    }
  },
  mounted: async function () {
    var jobList = await HTTPRequest.getRequest(this.endPoint + 'import_jobs/', null, null)
    this.jobList = jobList
  },
  computed: {
    ...mapState(['currentProfile', 'parameters', 'serverType', 'endPoint', 'profileId'])
  },
  components: {

  },
  methods: {
    async reloadJobs() {
      var jobList = await HTTPRequest.getRequest(this.endPoint + 'import_jobs/', null, null)
      this.jobList = jobList
    },
    async downloadExport(record) {
      console.log(record)
      const { file_path: urlDownload, profile_name, formatted_time_end } = record
      const downloadLink = await axios({
        method: 'post',
        responseType: 'blob', // important
        url: this.endPoint + "systems/full_sync/download_zip",
        headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source': "BXI-File" },
        data: { file_path: urlDownload }
      })

      const url = window.URL.createObjectURL(new Blob([downloadLink.data], { type: 'application/zip' }));
      const link = document.createElement('a');
      link.href = url;
      let site_code = profile_name.split("_")
      const extraction_date = formatted_time_end.split(" ")

      link.setAttribute('download', `${site_code[site_code.length - 1]}_full_sync_profiles_${_.snakeCase(extraction_date[0])}.zip`);
      document.body.appendChild(link);

      link.click();
      window.URL.revokeObjectURL(url);
    }
  }
}
</script>

<style scoped>

</style>